/**
 * Created by Ning Jiang on 2022-02-22.
 */

import {SerialSymbol} from "./SerialSymbol";
import {SerialSymbolState} from "./SerialSymbolConfig";
import {Serial} from "../Serial";

export class EmptySymbol extends SerialSymbol {

    constructor(reelId:number, symbolHeight:number, initState:SerialSymbolState) {
        super("E", reelId, symbolHeight, initState);
    }

    protected getStateTexture(state?:SerialSymbolState):PIXI.Texture[] {
        return Serial.assetLoader.getTextures(`E/E`);
    }

    protected updateSymbolHeight():void {

    }
}